import "./component.css"

export const Logo = () => {
  return (
     <div>
        <div className="logo">
           <img src="/assets/images/logo.png" alt="" />
           <p>Scorecard</p>
        </div>
     </div>
  );
}
